import { WOOTDASH_BASE } from '@/api/wootdash'

// Login contra o WootDash — único caminho de autenticação desde que o Chatwoot saiu de circulação
// (PLANO_MIGRACAO_WOOTDASH.md, Fase 0). As chamadas antigas ao Chatwoot que moravam aqui (perfil, sessões, avatar,
// inboxes, agentes, relatório e varredura de times/membros) foram removidas em 2026-10-13: nenhuma tela as usava de
// verdade, e "de quais times eu sou membro" agora vem de GET /agentes/eu/times (useMyTeamIds.ts).

interface WootDashLoginResponse {
  token: string
  expiresAt: string
  agentId: string
  firstName: string
  lastName: string
  chatwootId: number | null
  /** E-mail do agente (no Login Fallback o login digitado é o usuário do sistema ISBET). */
  email?: string | null
}

export interface WootDashSession {
  token: string
  expiresAt: string
  agentId: string
  firstName: string
  lastName: string
  // Id numérico do Chatwoot preservado pelo importador, quando o agente veio de lá —
  // usado como AuthUser.id pra manter compatibilidade com a configuração de permissão
  // local existente (useAdmin.ts, chaveada por id numérico). Nulo pra agente nascido
  // direto no WootDash (ver PLANO_MIGRACAO_WOOTDASH.md, Fase 0).
  chatwootId: number | null
  email?: string | null
}

/**
 * Login contra o WootDash. Lança erro em caso de falha — não há fallback pra tentar.
 */
/** Renova o token da sessão atual (antes de vencer). Nulo = sessão revogada, token já vencido ou sem rede. */
export async function renewWootDashToken(token: string): Promise<{ token: string; expiresAt: string } | null> {
  try {
    const res = await fetch(`${WOOTDASH_BASE}/autenticacao/renovar`, { method: 'POST', headers: { Authorization: `Bearer ${token}` } })
    if (!res.ok) return null
    const d = await res.json()
    return d?.token ? { token: d.token, expiresAt: d.expiresAt } : null
  } catch {
    return null
  }
}

export async function signInWootDash(email: string, password: string): Promise<WootDashSession> {
  const res = await fetch(`${WOOTDASH_BASE}/autenticacao/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password, device: 'wootdash-web' }),
  })
  if (!res.ok) {
    throw new Error(res.status === 401 ? 'Credenciais inválidas' : `Erro ao entrar (HTTP ${res.status})`)
  }
  const d: WootDashLoginResponse = await res.json()
  if (!d?.token) throw new Error('Resposta de login não trouxe token')
  return { token: d.token, expiresAt: d.expiresAt, agentId: d.agentId, firstName: d.firstName, lastName: d.lastName, chatwootId: d.chatwootId, email: d.email ?? null }
}
